import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Leaf, Ruler, Bot } from "lucide-react";
import { landscapeImages } from "@/lib/landscapeCatalog";

const LandscapeTeaser = () => (
  <section className="my-12 md:my-16">
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="relative overflow-hidden rounded-3xl border border-[hsl(var(--line))]">
        <img
          src={landscapeImages.hero}
          alt="Autonomous landscape robot mowing a professional turf field"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
          loading="lazy"
        />
        <div className="relative bg-gradient-to-r from-background via-background/85 to-background/30 p-7 md:p-10">
          <Badge className="mb-3 bg-primary/15 text-primary border border-primary/30">
            New Division
          </Badge>
          <h2 className="font-orbitron text-2xl md:text-3xl font-bold">
            Landscape &amp; Turf Robotics
          </h2>
          <p className="mt-3 text-sm md:text-base text-muted-foreground max-w-lg">
            Autonomous mowers and robotic line markers for golf courses, sports fields,
            municipalities, and estates — cutting labor cost on repetitive acreage by up to 90% and
            paint usage by more than half.
          </p>
          <div className="mt-5 flex flex-wrap gap-4 text-xs text-muted-foreground">
            <span className="inline-flex items-center gap-1.5">
              <Leaf className="h-3.5 w-3.5 text-primary" /> Professional mowing
            </span>
            <span className="inline-flex items-center gap-1.5">
              <Ruler className="h-3.5 w-3.5 text-primary" /> Robotic line marking
            </span>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button asChild className="rounded-full">
              <Link to="/robots/landscape">
                Explore Landscape Robots <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/industries/landscaping">Landscaping Solutions</Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden rounded-3xl border border-[#00A3FF]/25 bg-[#00A3FF]/5 p-7 md:p-10 flex flex-col justify-center">
        <Badge className="mb-3 w-fit bg-[#00A3FF]/15 text-[#00A3FF] border border-[#00A3FF]/30">
          Humanoid Division
        </Badge>
        <h2 className="font-orbitron text-2xl md:text-3xl font-bold">Humanoid Robotics Programs</h2>
        <p className="mt-3 text-sm md:text-base text-muted-foreground max-w-lg">
          NEXORA MINI™ and NEXORA ATLAS™ platforms, plus enterprise humanoid evaluation programs —
          assessed against your real workflow, piloted, then scaled.
        </p>
        <div className="mt-5 inline-flex items-center gap-1.5 text-xs text-muted-foreground">
          <Bot className="h-3.5 w-3.5 text-[#00A3FF]" /> Grounded capability claims only
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button asChild className="rounded-full">
            <Link to="/robots/humanoid">
              View Humanoid Platforms <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full">
            <Link to="/nexora">Explore NEXORA</Link>
          </Button>
        </div>
      </div>
    </div>
  </section>
);

export default LandscapeTeaser;
